export const PROJECT_CREATED_SUCCESS_TOAST_TEST_ID = 'project-created-success-toast'
